export enum EventNotificationTypes {
    commonCommentNotificationType,
    commentPerformanceManagerNotificationType,
    creationRespondentListNotificationType,
    processParticipationAssingnedNotificationType,
    confirmationRespondentsBusinessUnitAdministratorNotificationType,
    confirmationRespondentsPerformanceManagerNotificationType,
    anonymCommonCommentNotificationType,
    anonymCommentPerformanceManagerNotificationType,
}